import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  typeIcon: '',
  preTypeId: '',
  typeName: '',
  typeSort: '',
  typeShow: false
};
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '添加/编辑分类',
    auth: true,
    authorityValue: "store-store-subcate"
  },
  name: 'trade-add-edit',
  data: function data() {
    return {
      form: cloneDeep(initForm),
      uploadData: {
        data: {
          token: '',
          key: ''
        },
        accept: '.png,.jpeg,.jpg',
        class: 'avatar-uploader',
        action: 'https://up-z2.qiniup.com',
        'show-file-list': false,
        multiple: false
      },
      options: [],
      title: ''
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      this.$api.saveStoreGoodsType(this.form);
      this.goBack();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.form, key, this.VUE_APP_IMG_BASE + response.key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    getGoodsType: function getGoodsType() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$sto, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.storeGoodsTypes({
                  typeLevel: 1
                });

              case 2:
                _yield$_this$$api$sto = _context.sent;
                records = _yield$_this$$api$sto.records;
                _this.options = records;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getGoodsTypeDetails: function getGoodsTypeDetails(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var scok, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                scok = JSON.stringify(item) !== '{}';

                if (!scok) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 4;
                return _this2.$api.storeGoodsTypeDetails(item);

              case 4:
                data = _context2.sent;
                _this2.form = Object.assign(_this2.form, data);

                if (item.level == 2) {
                  _this2.title = '添加分类';
                  _this2.form = Object.assign(_this2.form, item);
                } else {
                  _this2.title = '编辑分类';
                }

                _context2.next = 11;
                break;

              case 9:
                _this2.title = '添加一级分类';
                _this2.form = Object.assign(_this2.form, item);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var query, _yield$_this3$$api$ge, token;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = _this3.$route.query;
              _context3.next = 3;
              return _this3.$api.getUploadToken();

            case 3:
              _yield$_this3$$api$ge = _context3.sent;
              token = _yield$_this3$$api$ge.token;
              _this3.uploadData.data.token = token;

              _this3.getGoodsType();

              _this3.getGoodsTypeDetails(query);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};